<div class="custom-modal">
	<div class="header">
		<h1 mat-dialog-title>
      Transformar produto em Risco
    </h1>
		<mat-icon mat-dialog-close="cancel">close</mat-icon>
	</div>
	<mat-divider></mat-divider>
	<div mat-dialog-content>
		<div *ngIf="isLoading" style="min-height: 120px" class="d-flex justify-content-center">
			<mat-spinner color="primary" mode="indeterminate"></mat-spinner>
    </div>
    <div 
      *ngIf="!isLoading && produtos?.length === 0"
      style="min-height: 120px"
      class="d-flex justify-content-center align-items-center">
        Nenhum registro encontrado!
    </div>
    <div class="no-padding" [hidden]="isLoading || produtos?.length === 0">
      <table mat-table [dataSource]="produtos">
        <ng-container matColumnDef="nrt">
          <th mat-header-cell *matHeaderCellDef>NRT</th>
          <td mat-cell *matCellDef="let element">{{ element.nrt }}</td>
        </ng-container>
        <ng-container matColumnDef="produtoOriginal">
          <th mat-header-cell *matHeaderCellDef>Produto Original</th>
          <td mat-cell *matCellDef="let element">{{ element.produtoOriginal }}</td>
        </ng-container>
        <ng-container matColumnDef="produtoRisco">
          <th mat-header-cell *matHeaderCellDef>Produto Risco</th>
          <td mat-cell *matCellDef="let element">{{ element.produtoRisco }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <app-paginacao
        [hidden]="paging.length < 6"
        [length]="paging.length"
        [pageIndex]="paging.index"
        [pageSize]="paging.size"
        (page)="pageChanged($event)"></app-paginacao>
    </div>
	</div>
	<div mat-dialog-actions class="d-flex justify-content-end align-items-end">
    <button mat-flat-button color="info" mat-dialog-close="cancel">Cancelar</button>
		<button
			mat-flat-button
      color="primary"
      (click)="confirmar()"
			[disabled]="isLoading">Confirmar</button>
	</div>
</div>